export interface IDataAPI {
   // 用户信息
   userInfo: string,
   // 用户排名
   getRanks:string,
   //激活老用户资格
  activateOldStatus:string,
  // 查询老用户
  serchOldUsers:string,
  // 获取用户当期投票记录
  voteHistory:string,
  // 绑定好友
  bindFriend:string,
  // toupiao
  voteTicket:string,
  // 获取用户昵称
  getNickname:string
}

export const dataAPI: IDataAPI = {
  // 用户信息
  userInfo: "http://gxhd.game.yy.com/zhhy/info.do",
  // 用户排名
  getRanks: "http://gxhd.game.yy.com/zhhy/getRank.do",
  
  //激活老用户资格
  activateOldStatus:"http://gxhd.game.yy.com/zhhy/register.do",

  // 查询老用户
  serchOldUsers:"http://gxhd.game.yy.com/zhhy/search.do",

  // 获取用户当期投票记录

  voteHistory:"http://gxhd.game.yy.com/zhhy/voteHistory.do",

  // 绑定好友

  bindFriend: "http://gxhd.game.yy.com/zhhy/bind.do",

  // 投票
  voteTicket:"http://gxhd.game.yy.com/zhhy/vote.do",

  getNickname:"http://gxhd.game.yy.com/zhhy/getNickname.do"
};


export default dataAPI;



// WEBPACK FOOTER //
// ./src/utils/api.ts